// libs
import React, { useCallback } from 'react';

import { cn } from '@lyearn/style';
// components
import { Switch, Typography } from '@lyearn/ui';
import { Stack } from '@lyearn/ui';

// types
import { SwitchWithInfoProps } from './types';

function SwitchWithInfo(props: SwitchWithInfoProps) {
  const {
    label,
    description,
    disabled = false,
    checked,
    classes,
    switchPlacement = 'end',
    onChange,
  } = props;

  const _onChange = useCallback(
    (_: any, value: boolean) => {
      onChange(value);
    },
    [onChange],
  );

  const renderSwitch = () => (
    <Switch
      checked={checked}
      className={cn('flex-shrink-0', { 'mt-4': switchPlacement === 'start' })}
      disabled={disabled}
      size={switchPlacement === 'start' ? 'small' : undefined}
      onChange={_onChange}
    />
  );

  return (
    <Stack
      className={classes?.container}
      gapX={16}
      justifyContent={switchPlacement === 'end' ? 'between' : undefined}>
      {switchPlacement === 'start' ? renderSwitch() : null}
      <Stack direction="col" gapY={4}>
        <Typography variant={classes?.description?.variant ?? 'body-short-01'}>{label}</Typography>
        <Typography
          className={switchPlacement === 'end' ? 'mt-2' : undefined}
          color={classes?.description?.color || 'text-text-secondary'}
          variant={classes?.description?.variant || 'body-short-02'}>
          {description}
        </Typography>
      </Stack>
      {switchPlacement === 'end' ? renderSwitch() : null}
    </Stack>
  );
}

export default React.memo(SwitchWithInfo);
